import BaseLine, { IEndInfo } from '../../line-base';

class BentConnector3 extends BaseLine {
    public constructor() {
        super();
        this.defaultValue.controlValues = [0.5];
    }

    public svgPathInRect = (x: number, y: number, w: number, h: number, controlValues: number[], endInfo: IEndInfo) => `M${x + ((controlValues[0] < 0 ? -1 : 1) * endInfo.head)} ${y} `
            + `L${x + (w * controlValues[0])} ${y} `
            + `L${x + (w * controlValues[0])} ${y + h} `
            + `L${x + w - ((controlValues[0] > 1 ? -1 : 1) * endInfo.tail)} ${y + h}`;

    public getControlPoints = (w: number, h: number) => {
        const controlValues = this.getControlValues();
        return [{
            x: w * controlValues[0],
            y: h / 2,
        }];
    };

    public setLineInfo = (x: number, y: number, w: number, h: number, controlValues: number[], endInfo: IEndInfo) => {
        this.startPos = {
            x: x + ((controlValues[0] < 0 ? -1 : 1) * endInfo.head),
            y,
        };
        this.endPos = {
            x: x + w - ((controlValues[0] > 1 ? -1 : 1) * endInfo.tail),
            y: y + h,
        };
    };
}

export default BentConnector3;
